import { render, staticRenderFns } from "./TableShimmer.vue?vue&type=template&id=954868ec&scoped=true&"
import script from "./TableShimmer.vue?vue&type=script&lang=js&"
export * from "./TableShimmer.vue?vue&type=script&lang=js&"
import style0 from "./TableShimmer.vue?vue&type=style&index=0&id=954868ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954868ec",
  null
  
)

export default component.exports